import { render, staticRenderFns } from "./InternalReports.vue?vue&type=template&id=151aaf24"
import script from "./InternalReports.vue?vue&type=script&lang=js"
export * from "./InternalReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports